import { render, staticRenderFns } from "./PaymentCancelView.vue?vue&type=template&id=3b684d0e&scoped=true&"
import script from "./PaymentCancelView.vue?vue&type=script&lang=js&"
export * from "./PaymentCancelView.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCancelView.vue?vue&type=style&index=0&id=3b684d0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b684d0e",
  null
  
)

export default component.exports